import React from 'react'

const handleActivityOpen=(item)=>{
    let user = JSON.parse(localStorage.getItem('myData'))
    let groupUser= user.user.groups[0]
    if(groupUser === 'ACOM'){
      if(item.data.Status === 'Draft' || item.data.Status === 'Sent Back By CDF' || item.data.Status === 'Sent Back By CDFM' || item.data.Status === 'Sent Back By CMD'){
          window.open(`/gtform/${item.data.guid}?activity_status=${item.data.Status==='Draft'?item.data.Status.toLowerCase():item.data.Status}/${item.data.PromomtionType === 'MTFTS' ? 'mt' : 'gt'}`)
      }else{
        window.open(`/promotionapproval/${item.data.guid}?activity_status=${item.data.Status}&${item.data.ActivityCode}`, '_blank');
      }
    }
    else {
        window.open(`/promotionapproval/${item.data.guid}?activity_status=${item.data.Status}&${item.data.ActivityCode}`, '_blank');
    }
  }

const ActivityPopUp = (props) => {
    return (
        <div className='main-div' style={props.popUP?null:{display:'none'}}>
            {props.popUP?<div className='close-transparent-div' onClick={props.handleActivityPopUpClose}></div>:null}
        <div className='activity-popup-container'
        
         >
            <div style={{display:'flex',justifyContent:'space-between'}}>
                <div className='tooltip-rows'>
                    <span className="bold-font">Activity Type: </span>
                    <span> {props.data.PromomtionType}</span>
                </div>
                <span className='promo-status' style={props.data.Status === "Draft"?{backgroundColor:'#FFEEE5',color:'#ff5e00'}
                          : props.data.Status === "Submitted By Acom"?{backgroundColor:'#E5F2FF',color:'#007fff'}
                          :props.data.Status === "Approved By CDF"?{backgroundColor:'#E5F2ED',color:'#008450'}
                          :props.data.Status === "Rejected By CDF"?{backgroundColor:'#F8E8E7',color:'#b81d13'}
                          :props.data.Status === "Sent Back By CDF"?{backgroundColor:'#FFF8E8',color:'#ffb822'}
                          :props.data.Status === "Approved By CDFM"?{backgroundColor:'#E5F2ED',color:'#008450'}
                          :props.data.Status === "Rejected By CDFM"?{backgroundColor:'#F8E8E7',color:'#b81d13'}
                          :props.data.Status === "Sent Back By CDFM"?{backgroundColor:'#FFF8E8',color:'#ffb822'}
                          :props.data.Status === "Approved By CMD"?{backgroundColor:'#E5F2ED',color:'#008450'}
                          :props.data.Status === "Rejected By CMD"?{backgroundColor:'#F8E8E7',color:'#b81d13'}
                          :props.data.Status === "Sent Back By CMD"?{backgroundColor:'#FFF8E8',color:'#ffb822'}:null}>
                          {props.data.Status}
                </span>
                <span className='close-x' onClick={props.handleActivityPopUpClose}>x</span>
            </div>

            <div className='tooltip-rows'>
                <span className="bold-font">Activity Code: </span>
                <span style={{color:'#48a9a6',cursor:'pointer'}} onClick={()=>handleActivityOpen(props)}><u> {props.data.ActivityCode}</u></span>
            </div>

            <div className='tooltip-rows'>
                <span className="bold-font">Procject Code: </span>
                <span> {props.data.ProjectCodes[0]}</span>
            </div>

            <div className='tooltip-rows'>
                <span className="bold-font">Activity ROI: </span>
                <span> {props.data.ActivityRoi}%</span>
            </div>

            <div className='tags-container'>

                <span className="bold-font" style={{marginTop:'0.2vw',marginRight:'5px'}}>{props.data.categories?'Category: ':props.data.brands?'Brands: ':props.data.master_skus?'Master Sku: ':props.data.skus?'SKU: ':null}</span>

                <span className='sub-container-tags'>
                {props.data.categories?
                props.data.categories.map((item,ind)=>(
                    <span className='tags' key={item+ind}>{item}</span>
                ))
                :
                props.data.brands?
                props.data.brands.map((item,ind)=>(
                    <span className='tags' key={item+ind}>{item}</span>
                ))
                :
                props.data.master_skus?
                props.data.master_skus.map((item,ind)=>(
                    <span className='tags' key={item+ind}>{item}</span>
                ))
                :
                props.data.skus?
                props.data.skus.map((item,ind)=>(
                    <span className='tags' key={item+ind}>{item}</span>
                ))
                :
                null
                }
                </span>

            </div>

            {props.data.MasterChannel.length?<div className='tags-container'>

                <span className="bold-font"  style={{marginTop:'0.2vw',marginRight:'5px'}}>Master Channel: </span>

                <span className='sub-container-tags'>
                {props.data.MasterChannel?
                props.data.MasterChannel.map((item,ind)=>(
                    <span className='tags' key={item+ind}>{item}</span>
                ))
                :
                null
                }
                </span>

            </div>:null}
            </div>
        </div>
    )
}

export default ActivityPopUp;